import * as React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  Snackbar,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { useLanguage } from "../../Language";
import { useAccount } from "../../Account";
import { GoogleSignInButton } from "../../GoogleSignInButton";
import { Link } from "react-router-dom";
import { ObrResponse } from "../../ObrResponse";

export const OBRSuccess = ({
  responseHTML,
  response: { borrower },
}: ObrResponse) => {
  const { translate } = useLanguage();
  const { isAuthenticated } = useAccount();
  const [open, setOpen] = React.useState<boolean>(true);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        onClose={() => setOpen(false)}
        autoHideDuration={5000}
      >
        <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
          {translate("obrAccountSuccessfullyAdded")}
        </Alert>
      </Snackbar>
      <Container>
        <Typography variant="h6" sx={{pt: 4, pb: 2}}>{`${borrower.firstName}${translate(
          "possession"
        )} ${translate("account")}`}</Typography>
        <div dangerouslySetInnerHTML={{ __html: responseHTML }}></div>
        <Stack direction={{ xs: "column", sm: "row" }} gap={1}>
          {/* Add another borrower workflow */}
          {isAuthenticated && !!borrower.responsibleAgencyNumber && (
            <Button type="button" component={Link} to={"/myaccount/linked"}>
              {translate("linkedAccountsTab")}
            </Button>
          )}

          {/* Normal workflow */}
          {!borrower.responsibleAgencyNumber && (
            <>
              {isAuthenticated && <Box>{translate("obrYouAreLoggedIn")}</Box>}
              {!isAuthenticated && borrower.googleId && (
                <GoogleSignInButton
                  onClick={() => (location.href = "/oauth2/callback")}
                ></GoogleSignInButton>
              )}
              <Button type="button" component={Link} to={"/myaccount/summary"}>
                {translate("myAccount")}
              </Button>
            </>
          )}
        </Stack>
      </Container>
    </>
  );
};
